"use client"

import type React from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import ExhibitionRelatedContainer from "../../../Component/Application/ExhibitionRelated/ExhibitionRelatedContainer"
import ExhibitionService from "../../../Service/ExhibitionService"
import type { Exhibition } from "../../../Component/Application/Exhibition/types"
import { toast } from "react-toastify"

const ExhibitionRelated: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [exhibition, setExhibition] = useState<Exhibition | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchExhibition = async () => {
      if (!id) {
        toast.error("Exhibition ID is required")
        navigate(`${process.env.PUBLIC_URL}/exhibition`)
        return
      }

      try {
        setLoading(true)
        const exhibitionData = await ExhibitionService.getById(Number(id))
        setExhibition(exhibitionData)
      } catch (error) {
        console.error("Failed to fetch exhibition:", error)
        toast.error("Failed to load exhibition details")
        navigate(`${process.env.PUBLIC_URL}/exhibition`)
      } finally {
        setLoading(false)
      }
    }

    fetchExhibition()
  }, [id, navigate])

  const handleBack = () => {
    navigate(`${process.env.PUBLIC_URL}/exhibition`)
  }

  if (loading) {
    return (
      <div className="page-body">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    )
  }

  if (!exhibition) {
    return (
      <div className="page-body">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
          <div className="text-center">
            <h4>Exhibition not found</h4>
            <button className="btn btn-primary mt-3" onClick={handleBack}>
              Back to Exhibitions
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="page-body">
      <ExhibitionRelatedContainer  />
    </div>
  )
}

export default ExhibitionRelated
